import { mapState } from 'vuex';
export default {
  name: 'TextInputField',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    canAddRule: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled'])
  }
};